<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">گزارش برچسب کالیبراسیون</h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">تاریخ شروع</label>
        <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..."   class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">تاریخ پایان</label>
        <input type="text" #datepickerInputEnd  placeholder="اینجا تایپ کنید ..."  class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> نام دستگاه </label>
        <input  type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> نام مشتری </label>
        <input  type="text" class="form-control" name="Customer_Filter_List" [(ngModel)]="Customer_Filter_List"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
    </div>

     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing"  type="button" (click)="ReadData_Certificate(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <button *ngIf="!Procssing" (click)="exportexcel()" type="button"  class="btn btn-warning" style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Certificate No</th>
              <th colspan="2">Calibration Date</th>
              <th colspan="2">Recal. Date</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Certificate
            | paginate
                    : {
                        id: 'Data_Seleted_Certificate',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Certificate).length
                      }
            ">
            <td>{{DataList_Certificate.indexOf(item)+1}}</td>
            <td>{{item.device_code}}</td>
            <td>{{item.certificate_no}}</td>
            <td>{{item.calibration_date}}</td>
            <td class="EnglishClm">{{item.calibration_date_milad}}</td>
            <td>{{item.recal_date}}</td>
            <td class="EnglishClm">{{item.recal_date_milad}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a target="_blank"  href="{{BaseUrl}}{{item.link}}" class="dropdown-item" ><i class="fa fa-qrcode"></i> گواهی نامه </a>
                    </div>
                </div>
              </div>
            </td>
            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="Data_Seleted_Certificate"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>


<table style="display: none;" id="excel-table">
  <thead>
    <tr>
      <th>#</th>
      <th>ID</th>
      <th>Certificate No</th>
      <th>Calibration Date</th>
      <th>Calibration Date</th>
      <th>Recal. Date</th>
      <th>Recal. Date</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Certificate">
     <td>{{DataList_Certificate.indexOf(item)+1}}</td>
     <td>{{item.device_code}}</td>
     <td>{{item.certificate_no}}</td>
     <td>{{item.calibration_date}}</td>
     <td>{{item.calibration_date_milad}}</td>
     <td>{{item.recal_date}}</td>
     <td>{{item.recal_date_milad}}</td>
    </tr>
  </tbody>
</table>
